import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';
import { ReactComponent as Pointer } from 'src/Images/icons/common/pointer.svg';
import {
  getWorkflowStagesDataForUpcomingStageRequest,
  createUpcomingWorkflowStageRequest,
  getUpcomingWorkflowStageRequest,
  getVehicleTrackingDetail,
  getTimelineData,
} from 'src/redux/Actions/VehicleTracking';

export default function UpcomingWorkflowStageRequestDrawer({
  vehicleTrackingDetails,
  onClose,
  setDrawerStep,
}) {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const { vehicleTrackingNumber, workflowStageId } = useParams();
  const organisationId = authReducer.userData.organisations?.id;

  const vehicleTrackingDataReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const { workflowStagesDataForUpcomingStageRequest: timelineData } =
    vehicleTrackingDataReducer;

  useEffect(() => {
    dispatch(
      getWorkflowStagesDataForUpcomingStageRequest(
        vehicleTrackingNumber,
        organisationId,
      ),
    );
  }, [dispatch, vehicleTrackingNumber, organisationId]);

  const currentIndex =
    timelineData?.findIndex((item) => item.is_current_workflow_stage) ?? -1;

  const handleChooseStation = (stageId) => {
    dispatch(
      createUpcomingWorkflowStageRequest({
        tenant_organisation_id: organisationId,
        vehicle_tracking_number: vehicleTrackingNumber,
        requested_workflow_stage_id: stageId,
      }),
    ).then(() => {
      dispatch(
        getUpcomingWorkflowStageRequest(vehicleTrackingNumber, organisationId),
      );
      dispatch(
        getVehicleTrackingDetail(
          vehicleTrackingNumber,
          organisationId,
          workflowStageId,
        ),
      );
      dispatch(getTimelineData(vehicleTrackingNumber, organisationId));
      setDrawerStep('confirm');
    });
  };

  return (
    <div
      className={`theme-scrollable-container-${themeColor} div-flex-column rg-10 change-station-timeline`}
    >
      <div className="div-flex-row div-align-center div-space-between padding-top-10 padding-bottom-10 horizontal-padding-10 border-bottom">
        <div className="div-flex-row div-align-center cg-10">
          <div className="text-lg text-semi-bold">Change Station</div>
          <span className="text-sm grey-pill-bg">
            {vehicleTrackingDetails?.workflowName}
          </span>
        </div>
        <button className="icon-btn-none" onClick={onClose} aria-label="Close">
          <Close className="icon-size-sm" />
        </button>
      </div>

      <ul
        className={`timeline-list-container theme-scrollable-container-${themeColor}`}
      >
        {timelineData?.map((logData, index) => {
          let className = 'timeline-progress',
            statusPill = null;

          if (index < currentIndex) {
            className = 'timeline-progress is-complete';
          } else if (logData.is_current_workflow_stage) {
            className = 'timeline-progress is-current';
          }

          if (logData.is_current_workflow_stage) {
            statusPill = (
              <div className="div-flex-row cg-5 div-align-center timeline-orange-pill-bg">
                <Pointer className="icon-size-xxs" color="#F88F14" />
                <span className="text-xs text-yellow">Current Station</span>
              </div>
            );
          } else if (index < currentIndex) {
            statusPill = (
              <div className="div-flex-row cg-5 div-align-center timeline-green-pill-bg">
                <Pointer className="icon-size-xxs" color="#0E9A26" />
                <span className="text-xs text-green">Completed</span>
              </div>
            );
          }

          return (
            <li className={className} key={logData.workflow_stage_id}>
              <div className="time-text-header div-flex-column rg-30">
                <div className="div-flex-row cg-10 div-align-center">
                  <div className="div-flex-row time-text-header cg-10">
                    <div>
                      <span className="text-md text-bold">
                        {logData.workflow_stage_name}
                      </span>
                    </div>

                    {statusPill}
                  </div>

                  {logData.skipped && (
                    <div className="status-pill red">
                      <span className="text-xs">Skipped</span>
                    </div>
                  )}
                </div>

                <div className="padding-bottom-10 border-bottom">
                  <button
                    disabled={!logData.eligible}
                    className={`vehicle-tracking-detail-move-stage-btn div-align-center theme-background-${themeColor} ${
                      !logData.eligible ? 'btn-disabled' : ''
                    }`}
                    onClick={() =>
                      logData.eligible &&
                      handleChooseStation(logData.workflow_stage_id)
                    }
                  >
                    <span className="text-sm">Choose Station</span>
                  </button>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
